import React from "react";
import {
  Breadcrumbs,
  Link,
  Drawer,
  Divider,
  Typography, Paper,
} from "@material-ui/core";
import { HomeOutlined } from "@material-ui/icons";
import useStyles from "../../styles/accountCenterStyle.js";
import { useTranslation } from "../../langs/useTranslation";
import "../../css/companyDevice.scss"
import CompanyDeviceProvider from '@/containers/CompanyDevice/Provider';
import Category from './Category';
import DeviceList from '@/containers/CompanyDevice/DeviceList';
import { Resizable } from "re-resizable";
const DevicesGroups = () => {
  const classes = useStyles();
  const { t } = useTranslation("devicesGroups");

  return (
    <div className={`${classes.root} company-device-container`}>
      <main className={`${classes.content} company-device-container-main`}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/">
            <HomeOutlined />
            {t({ defaultMessage: "首页" })}
          </Link>
          <Typography color="textPrimary">
            {t("devicesGroups.title")}
          </Typography>
        </Breadcrumbs>

        <div className={'header-box'}>
          <Typography variant="h4">{t("devicesGroups.title")}</Typography>
          <Typography>{t("devicesGroups.description")}</Typography>
        </div>

        <div className={`company-device-box ${classes.groupWrapper}`}>
          <CompanyDeviceProvider>
            <Resizable
              defaultSize={{
                minWidth: 250,
                width: 300
              }}
              enable={{
                top: false,
                right: true,
                bottom: false,
                left: false,
                topRight: false,
                bottomRight: false,
                bottomLeft: false,
                topLeft: false
              }}
              className={classes.sizableGroupWrapper}
            >
              <Paper elevation={0} className={`company-device-box-left`}>
                <Category />
              </Paper>
            </Resizable>
            <DeviceList />
          </CompanyDeviceProvider>
        </div>

      </main>
    </div>
  );
};

export default DevicesGroups;
